import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "src/app/core/auth/auth.guard";
import { CanActivateChildGuard } from "src/app/core/guards/can-activate-child.guard";
import { UploadFileDigitalComponent } from "./upload-file-digital/upload-file-digital.component";
import { AddLotMohaDigitalComponent } from "./add-lot-moha-digital/add-lot-moha-digital.component";

const routes: Routes = [
  { path: "", component: UploadFileDigitalComponent,
    data: { breadcrumb: ['breadcrumbs.my_contracts', 'title.create_contract_lot_moha'] } },
  { path: "add-lot", component: AddLotMohaDigitalComponent,
    data: { breadcrumb: ['breadcrumbs.my_contracts', 'title.create_contract_lot_moha'] } },
  { path: "add-lot/:id", component: AddLotMohaDigitalComponent,
    data: { breadcrumb: ['breadcrumbs.my_contracts', 'title.view_lot_moha'] } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractDigitalAddLotRoutingModule { }
